import React, { FC } from 'react'

// Nextjs
import dynamic from 'next/dynamic'

// MUI
import { Box, Container } from '@mui/material'

// Constnats
import { CONSTANTS } from '@/constants'

// Common
import LoadingSection from '@/components/common/loading'

// UI
import { PaddTwentyFour } from '@/ui'
import { SectionSubTitle, SectionTitle } from './styles'

// Gallery Components
import BadGallerySection from './bed-gallery'

const SofaGallerySection = dynamic(() => import('./sofa-gallery'), { ssr: false, loading: () => <LoadingSection /> })
const WallpaperGallerySection = dynamic(() => import('./wallpaper-gallery'), { ssr: false, loading: () => <LoadingSection /> })
const ChairGallerySection = dynamic(() => import('./chair-gallery'), { ssr: false, loading: () => <LoadingSection /> })

const GallerySection: FC = () => {
  return (
    <Box sx={{ py: theme => theme.typography.pxToRem(70) }}>
      <Container maxWidth="md">
        <PaddTwentyFour>
          <Box sx={{ textAlign: 'center' }}>
            <SectionTitle>Wonderful work with all our clients</SectionTitle>

            <SectionSubTitle>
              With the courage to innovate, {CONSTANTS.APP_NAME} creates <strong style={{ color: '#000' }}>trends</strong> and unique furnishing collections being affordable and desirable for all
              people. A s an international supplier and generator of change {CONSTANTS.APP_NAME} continues creating new furnishing designs.
            </SectionSubTitle>
          </Box>
        </PaddTwentyFour>
      </Container>

      <Container maxWidth="xl">
        <PaddTwentyFour>
          <BadGallerySection />

          <SofaGallerySection />

          <WallpaperGallerySection />

          <ChairGallerySection />
        </PaddTwentyFour>
      </Container>
    </Box>
  )
}

export default GallerySection
